const PLANNER_TIER_PATH = '/billing/checkout/planner';
const PACKAGE_PATH = '/billing/checkout';

/**
 * Whether a post-auth destination ends in a planner purchase, so the page can
 * say what the account is for instead of showing a bare sign-in form.
 *
 * Two shapes qualify: the printable tier route, and a billing package carrying a
 * `feedId` — that param is what makes the purchase build a planner from a
 * calendar (see the checkout modal's link.lib), so without it the package is an
 * ordinary subscription and gets no planner treatment.
 */
export const isPlannerCheckoutDestination = (
  destination: string | undefined
): boolean => {
  if (!destination) return false;
  if (destination.startsWith(PLANNER_TIER_PATH)) return true;

  const [pathname, search] = destination.split('?');
  return pathname === PACKAGE_PATH && new URLSearchParams(search).has('feedId');
};
